export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CA-7278655ab7f69865e2f9c631e27b6032.png";